import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtokolhapurcab() {



    const cardData = {




keyword: "Belgaum to Kolhapur Cab",

headingDescription: "Belgaum Taxi Service provides comfortable and affordable Belgaum to Kolhapur cab services for business travel, family visits, medical trips, pilgrimage tours, shopping trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Kolhapur, we offer reliable transportation with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel needs. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth and convenient journey. Belgaum Taxi Service connects travelers between Belgaum and Kolhapur for personal, corporate, religious, and leisure travel with safe and comfortable cab solutions.",

topPlaces: [
  {
    title: "Mahalaxmi Temple Kolhapur",
    description: "Mahalaxmi Temple is one of the most famous pilgrimage destinations in Kolhapur, attracting devotees from Belgaum and nearby cities throughout the year."
  },
  {
    title: "Rankala Lake",
    description: "Rankala Lake is a popular tourist attraction in Kolhapur known for its scenic beauty, peaceful atmosphere, boating, and evening views."
  },
  {
    title: "Panhala Fort",
    description: "Panhala Fort is a historic hill fort near Kolhapur famous for Maratha history, beautiful landscapes, and panoramic views."
  },
  {
    title: "Kolhapuri Chappal Market",
    description: "Kolhapuri markets are famous for traditional footwear, handicrafts, shopping, and local products, making them a popular destination for visitors."
  },
  {
    title: "Khasbag Wrestling Stadium",
    description: "Khasbag Wrestling Stadium is a historic sports venue in Kolhapur known for traditional wrestling culture and local heritage."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and business hub in Maharashtra. Comfortable cab services are preferred for corporate travel, airport transfers, and family journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital and a popular destination for business, medical, airport, and personal travel from Kolhapur and Belgaum."
  },
  {
    title: "Goa",
    description: "Goa is a famous holiday destination known for beaches, resorts, churches, and sightseeing attractions. Private cabs offer a comfortable travel option for vacation trips."
  },
  {
    title: "Nashik",
    description: "Nashik is a popular religious and tourist destination known for temples, vineyards, and cultural attractions, making it a preferred long-distance travel destination."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station famous for viewpoints, strawberry farms, waterfalls, and pleasant weather, ideal for family vacations and weekend trips."
  }
],




"services": [
  {
    "name": "Airport Taxi Belgaum",
    "description": "Book Airport Taxi Belgaum for safe, comfortable, and punctual airport transfers with professional chauffeurs and well-maintained AC vehicles. Get reliable pickup and drop services from Belgaum Airport with Sedan, Ertiga, Innova Crysta, and SUV cab options available for passengers, families, and business travelers."
  },
  {
    "name": "Belgaum Airport Taxi",
    "description": "Choose Belgaum Airport Taxi for hassle-free airport transportation with experienced drivers, clean vehicles, affordable fares, and timely service. Enjoy convenient airport pickup and drop facilities with doorstep cab availability for local and outstation travel."
  },
  {
    "name": "Belgaum Airport Taxi Service",
    "description": "Book Belgaum Airport Taxi Service for reliable airport transfers with professional drivers, comfortable seating, and smooth travel experiences. Our taxi services are suitable for arrivals, departures, business trips, family travel, and long-distance journeys."
  },
  {
    "name": "Belgaum Airport to Goa Taxi Fare",
    "description": "Get affordable Belgaum Airport to Goa Taxi Fare with comfortable AC cabs and experienced chauffeurs. Travel conveniently from Belgaum Airport to North Goa, South Goa, and popular destinations with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Goa Airport Taxi Charges",
    "description": "Check Belgaum to Goa Airport Taxi Charges for budget-friendly and reliable airport transfer services. Choose from Sedan, Ertiga, Innova Crysta, and SUV vehicles with transparent pricing and professional driver assistance."
  },
  {
    "name": "Goa Airport to Belgaum Taxi",
    "description": "Book Goa Airport to Belgaum Taxi for comfortable and safe transportation between Goa Airport and Belgaum. Enjoy timely pickup, spacious vehicles, experienced chauffeurs, and convenient travel solutions for personal and business journeys."
  },
  {
    "name": "Taxi from Belgaum Airport",
    "description": "Hire Taxi from Belgaum Airport for quick and reliable transportation to nearby cities and destinations. Get clean AC cars, professional drivers, doorstep drop services, and flexible cab options according to your travel needs."
  },
  {
    "name": "Best Taxi Service in Belgaum",
    "description": "Choose the Best Taxi Service in Belgaum offering premium vehicles, skilled chauffeurs, affordable rates, and dependable travel solutions. Perfect for airport transfers, local rides, outstation trips, corporate travel, and family journeys."
  },
  {
    "name": "Best Cab Service in Belgaum",
    "description": "Book the Best Cab Service in Belgaum for comfortable and reliable transportation with modern vehicles and experienced drivers. Enjoy convenient booking options for airport travel, local transportation, and outstation destinations."
  },
  {
    "name": "Taxi Service in Belgaum",
    "description": "Get Taxi Service in Belgaum for safe and affordable travel with professional chauffeurs and well-maintained vehicles. Our taxi solutions include local rides, airport transfers, corporate travel, and long-distance cab services."
  },
  {
    "name": "Cab Service in Belgaum",
    "description": "Choose Cab Service in Belgaum for reliable transportation with multiple vehicle choices including Sedan, Ertiga, Innova Crysta, and SUV cabs. Enjoy comfortable journeys with experienced drivers and easy booking facilities."
  },
  {
    "name": "Belgaum Taxi Service",
    "description": "Book Belgaum Taxi Service for convenient city travel, airport transfers, and outstation journeys. Experience safe rides with clean vehicles, professional drivers, transparent pricing, and flexible travel options."
  },
  {
    "name": "Belgaum Cab Service",
    "description": "Reserve Belgaum Cab Service for affordable and dependable travel solutions. Our chauffeur-driven cabs are ideal for airport pickup, family trips, business travel, sightseeing, and intercity transportation."
  },
  {
    "name": "Online Taxi Booking in Belgaum",
    "description": "Complete Online Taxi Booking in Belgaum with easy reservations, quick confirmation, and multiple cab options. Book comfortable taxis for airport transfers, local travel, and outstation trips with flexible scheduling."
  },
  {
    "name": "Online Cab Booking in Belgaum",
    "description": "Book Online Cab Booking in Belgaum services with simple booking procedures, transparent fares, and reliable customer support. Choose from different vehicle categories for personal, corporate, and family travel requirements."
  },
  {
    "name": "Outstation Cab Service in Belgaum",
    "description": "Hire Outstation Cab Service in Belgaum for safe and comfortable long-distance travel. Get one way cabs, round trip taxis, and customized travel packages with experienced chauffeurs and premium vehicles."
  },
  {
    "name": "One Way Cab Service in Belgaum",
    "description": "Book One Way Cab Service in Belgaum for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable AC vehicles, professional drivers, and convenient doorstep pickup facilities."
  },
  {
    "name": "Local Taxi Service in Belgaum",
    "description": "Choose Local Taxi Service in Belgaum for smooth city transportation, quick rides, and daily travel needs. Get reliable cabs for shopping, meetings, sightseeing, airport transfers, and local destinations."
  },
  {
    "name": "Airport Taxi Service in Belgaum",
    "description": "Book Airport Taxi Service in Belgaum for timely airport pickup and drop with experienced chauffeurs and comfortable vehicles. Enjoy stress-free airport transfers with 24x7 cab availability."
  },
  {
    "name": "Belgaum Airport Cab Service",
    "description": "Reserve Belgaum Airport Cab Service for reliable airport transportation with clean AC cars and professional drivers. Experience smooth pickup and drop services with affordable fares and convenient booking options."
  },
  {
    "name": "Innova Crysta Cab in Belgaum",
    "description": "Book Innova Crysta Cab in Belgaum for premium and spacious travel with luxury seating, large luggage capacity, and experienced chauffeurs. Ideal for airport transfers, corporate trips, family tours, and outstation journeys."
  },
  {
    "name": "Ertiga Cab Service in Belgaum",
    "description": "Choose Ertiga Cab Service in Belgaum for comfortable 6 to 7 seater travel with affordable pricing and spacious interiors. Perfect for family trips, airport transfers, group travel, and outstation routes."
  },
  {
    "name": "Cheap Taxi Service in Belgaum",
    "description": "Find Cheap Taxi Service in Belgaum with budget-friendly fares, quality vehicles, and reliable chauffeur services. Enjoy affordable transportation without compromising safety, comfort, and service standards."
  },
  {
    "name": "24/7 Taxi Service in Belgaum",
    "description": "Get 24/7 Taxi Service in Belgaum with round-the-clock cab availability, professional drivers, and well-maintained vehicles. Travel anytime with reliable taxi solutions for emergency, airport, and outstation requirements."
  },
  {
    "name": "Private Taxi Service in Belgaum",
    "description": "Choose Private Taxi Service in Belgaum for exclusive chauffeur-driven travel with privacy, comfort, and flexible schedules. Ideal for families, corporate travelers, airport transfers, and personalized journeys."
  },
  {
    "name": "Reliable Cab Service in Belgaum",
    "description": "Experience Reliable Cab Service in Belgaum with trusted drivers, comfortable vehicles, affordable pricing, and timely service. We provide dependable taxi solutions for local travel, airport transportation, and outstation trips."
  }
],
"tableData": [
  ["Airport Taxi Belgaum", "Belgaum Airport Taxi"],
  ["Belgaum Airport Taxi Service", "Belgaum Airport to Goa Taxi Fare"],
  ["Belgaum to Goa Airport Taxi Charges", "Goa Airport to Belgaum Taxi"],
  ["Taxi from Belgaum Airport", "Best Taxi Service in Belgaum"],
  ["Best Cab Service in Belgaum", "Taxi Service in Belgaum"],
  ["Cab Service in Belgaum", "Belgaum Taxi Service"],
  ["Belgaum Cab Service", "Online Taxi Booking in Belgaum"],
  ["Online Cab Booking in Belgaum", "Outstation Cab Service in Belgaum"],
  ["One Way Cab Service in Belgaum", "Local Taxi Service in Belgaum"],
  ["Airport Taxi Service in Belgaum", "Belgaum Airport Cab Service"],
  ["Innova Crysta Cab in Belgaum", "Ertiga Cab Service in Belgaum"],
  ["Cheap Taxi Service in Belgaum", "24/7 Taxi Service in Belgaum"],
  ["Private Taxi Service in Belgaum", "Reliable Cab Service in Belgaum"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Kolhapur Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service offers comfortable Belgaum to Kolhapur cab services with professional drivers, well-maintained vehicles, and safe transportation for every journey."
  },
  {
    WhyChooseheading: "Convenient Pickup from Belgaum",
    WhyChoosedescription: "Enjoy doorstep pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby locations with direct drop at your preferred destination in Kolhapur."
  },
  {
    WhyChooseheading: "Comfortable Fleet Options",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and premium cabs based on your passenger count and travel needs."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Service",
    WhyChoosedescription: "Book a one-way Belgaum to Kolhapur cab or choose a round-trip taxi package with flexible schedules and convenient travel options."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Journey",
    WhyChoosedescription: "Our professional chauffeurs have excellent route knowledge and ensure a smooth, secure, and comfortable journey from Belgaum to Kolhapur."
  },
  {
    WhyChooseheading: "Affordable Belgaum to Kolhapur Taxi Fare",
    WhyChoosedescription: "Get competitive taxi fares with transparent pricing, customized travel packages, and no hidden charges for your outstation trip."
  },
  {
    WhyChooseheading: "Ideal for Business & Family Travel",
    WhyChoosedescription: "Our Belgaum to Kolhapur cabs are suitable for business meetings, family visits, airport transfers, medical travel, and sightseeing trips."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Reserve your Belgaum to Kolhapur taxi anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Kolhapur Cab Service?",
    answer: "Yes, we provide reliable Belgaum to Kolhapur cab services with comfortable vehicles and experienced drivers."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Kolhapur?",
    answer: "Yes, one-way taxi services are available with convenient pickup from any location in Belgaum."
  },
  {
    question: "Which cars are available for Belgaum to Kolhapur travel?",
    answer: "We provide Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and other comfortable vehicles."
  },
  {
    question: "Do you provide Belgaum Airport to Kolhapur taxi service?",
    answer: "Yes, we provide direct taxi services from Belgaum Airport to Kolhapur with timely pickup and comfortable travel."
  },
  {
    question: "Can I book an Innova Crysta or Ertiga cab from Belgaum to Kolhapur?",
    answer: "Yes, Innova Crysta, Ertiga, Sedan, and other vehicle options are available according to your travel requirements."
  },
  {
    question: "Is Belgaum to Kolhapur taxi service available 24/7?",
    answer: "Yes, our cab services are available 24 hours a day for local and outstation travel."
  },
  {
    question: "Can I book a round-trip cab from Kolhapur to Belgaum?",
    answer: "Yes, round-trip and return taxi services are available with flexible travel schedules."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Is this cab service suitable for family and corporate travel?",
    answer: "Yes, our Belgaum to Kolhapur taxi service is suitable for families, corporate travelers, airport transfers, and personal trips."
  },
  {
    question: "How can I book a Belgaum to Kolhapur Cab?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback: "The Belgaum to Kolhapur cab service was excellent. The driver was punctual, the car was clean, and the complete journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Deshmukh",
    feedback: "We booked a taxi from Belgaum to Kolhapur and had a smooth travel experience. The service was reliable, affordable, and professionally managed.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Kolhapur Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-kolhapur-cab.webp",
  "description":
    "Book Belgaum to Kolhapur Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Kolhapur with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, business travel, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-kolhapur-cab"
  }
};





    return (
        <div>


<Helmet>
  <title>Belgaum to Kolhapur Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Kolhapur Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Kolhapur with Sedan, Ertiga, SUV, Innova, and Innova Crysta for airport transfers, business trips, and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="belgaum to kolhapur cab, belgaum airport to kolhapur taxi, belgaum to kolhapur distance taxi, belgaum to kolhapur taxi, belgaum to kolhapur taxi fare, Belgaum to Kolhapur Cab, Belgaum to Kolhapur Taxi, Belgaum to Kolhapur Cab Service, Belgaum to Kolhapur Taxi Service, Belgaum to Kolhapur One Way Cab, Belgaum to Kolhapur Cab Booking, Belgaum to Kolhapur Outstation Taxi, Belgaum to Kolhapur Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtokolhapurcab;